import { gsapSingleton, scrollTriggerSingleton } from "../gsap";
import $ from 'jquery';
import Component from '../models/Component';

const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();

gsap.registerPlugin(ScrollTrigger);

export default class Smoke extends Component {
  constructor(element, context) {
    super(element, context);

    $(() => {

      const baseDuration = 6;
      const fadeInDuration = 2;
      const totalDuration = baseDuration + fadeInDuration;
      
      // desktop
      const smokeEls = this.element.find(".smoke-hero"); 

      const tl1 = gsap.timeline({ repeat: -1 }); 
      tl1
        .fromTo(
          smokeEls[0],
          { y: 30, opacity: 1 },
          {
            y: -50,
            opacity: 0,
            duration: baseDuration,
            ease: "none",
            onComplete: () => {
              gsap.set(smokeEls[0], { y: 50, opacity: 0 });
            }
          }
        )
        .fromTo(
          smokeEls[0],
          { y: 50, opacity: 0 },
          {
            y: 30,
            opacity: 1,
            duration: fadeInDuration,
            ease: "none"
          }
        );
      const tl2 = gsap.timeline({ repeat: -1, delay: totalDuration / 2 });
      tl2
        .fromTo(
          smokeEls[1],
          { y: 30, opacity: 1 },
          {
            y: -50,
            opacity: 0,
            duration: baseDuration,
            ease: "none",
            onComplete: () => {
              gsap.set(smokeEls[1], { y: 50, opacity: 0 });
            }
          }
        )
        .fromTo(
          smokeEls[1],
          { y: 50, opacity: 0 },
          {
            y: 30,
            opacity: 1,
            duration: fadeInDuration,
            ease: "none"
          }
        );


      // mobile
      const smokeElsMobile = this.element.find(".smoke-hero-mobile"); 

      const tl1Mobile = gsap.timeline({ repeat: -1 }); 
      tl1Mobile
        .fromTo(
          smokeElsMobile[0],
          { y: 10, opacity: 1 },
          {
            y: -20,
            opacity: 0,
            duration: baseDuration,
            ease: "none",
            onComplete: () => {
              gsap.set(smokeEls[0], { y: 30, opacity: 0 });
            }
          }
        )
        .fromTo(
          smokeElsMobile[0],
          { y: 20, opacity: 0 },
          {
            y: 10,
            opacity: 1,
            duration: fadeInDuration,
            ease: "none"
          }
        );
      const tl2Mobile = gsap.timeline({ repeat: -1, delay: totalDuration / 2 });
      tl2Mobile
        .fromTo(
          smokeElsMobile[1],
          { y: 10, opacity: 1 },
          {
            y: -20,
            opacity: 0,
            duration: baseDuration,
            ease: "none",
            onComplete: () => {
              gsap.set(smokeEls[1], { y: 20, opacity: 0 });
            }
          }
        )
        .fromTo(
          smokeElsMobile[1],
          { y: 20, opacity: 0 },
          {
            y: 10,
            opacity: 1,
            duration: fadeInDuration,
            ease: "none"
          }
        );

    });
  }
}
